import Cookies from 'js-cookie'
import { VOLUUM_CID_COOKIE } from 'constants/voluum-handling'

export const createVoluumCookie = (cid: string) => {
  return Cookies.set(VOLUUM_CID_COOKIE, cid, { expires: 180 })
}

export const getVoluumCookie = () => {
  return Cookies.get(VOLUUM_CID_COOKIE)
}
